import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import classnames from 'classnames';
import styles from './Copyright.css';
export const Copyright = memo(function Copyright({ className }) {
    const containerClassName = classnames(styles.container, className);
    return (_jsx("div", Object.assign({ className: containerClassName }, { children: _jsxs("span", Object.assign({ className: styles.label }, { children: ["\u00A9 AstraZeneca ", new Date().getFullYear()] }), void 0) }), void 0));
});
